<script setup lang="ts">
import { getUrlParamsFromCriteria } from '@@/shared/property/url-serp';
import { getEmptySearchCriteria, type PropertySearchCriteria } from '@@/shared/property/search-criteria';
import type { IadAppRoute } from '~/application';

const emit = defineEmits<{
  select: []
}>();
const { locale } = useI18n();

function navigationSerpRouteLink(criteria: PropertySearchCriteria): IadAppRoute<`serp-serpSlug`> {
  const params = getUrlParamsFromCriteria(locale.value, criteria);
  return {
    name: 'serp-serpSlug',
    params: {
      serpSlug: params.serpSlug,
    },
  };
}

const emptySearchCriteria = getEmptySearchCriteria();

const appartmentLink = computed<IadAppRoute<`serp-serpSlug`>>(() => navigationSerpRouteLink({
  ...emptySearchCriteria,
  transactionType: 'rental',
  propertyTypes: ['apartment'],
}));
const houseLink = computed<IadAppRoute<`serp-serpSlug`>>(() => navigationSerpRouteLink({
  ...emptySearchCriteria,
  transactionType: 'rental',
  propertyTypes: ['house'],
}));
const businessLink = computed<IadAppRoute<`serp-serpSlug`>>(() => navigationSerpRouteLink({
  ...emptySearchCriteria,
  transactionType: 'rental',
  propertyTypes: ['business'],
}));

function onClick() {
  emit('select');
}
</script>

<template>
  <div class="flex flex-col text-lg gap-l">
    <div class="border-b border-black/10 flex flex-col gap-m pb-l">
      <div class="flex flex-col gap-l">
        <span
          class="lg:hidden text-lg font-semibold group-[.is-prestige]:text-xl group-[.is-prestige]:font-normal group-[.is-prestige]:uppercase"
          v-text="$t('core.navigation.rent')"
        />
        <span
          class="font-normal"
          v-text="$t('core.header.your_research')"
        />
      </div>
      <div class="flex flex-col gap-xl pl-m">
        <MainHeaderMenuItemLink
          variant="submenu"
          :text="$t('property.types_and_sub_types.apartment')"
          :to="appartmentLink"
          menu-category1="rent"
          menu-category2="apartment"
          @click="onClick"
        />
        <MainHeaderMenuItemLink
          variant="submenu"
          :text="$t('property.types_and_sub_types.house')"
          :to="houseLink"
          menu-category1="rent"
          menu-category2="house"
          @click="onClick"
        />
        <MainHeaderMenuItemLink
          variant="submenu"
          :text="$t('property.types_and_sub_types.commercial')"
          :to="businessLink"
          menu-category1="rent"
          menu-category2="business"
          @click="onClick"
        />
      </div>
    </div>
    <div class="flex flex-col gap-m">
      <span
        class="text-lg font-normal"
        v-text="$t('core.header.supporting_project')"
      />
      <div class="flex flex-col gap-xl pl-m">
        <MainHeaderMenuItemLink
          v-if="locale === 'fr'"
          variant="submenu"
          :text="$t('core.header.menu.location_tips')"
          href="https://blog.iadfrance.fr/conseil-immobilier/location/"
          target="_blank"
          menu-category1="rent"
          menu-category2="rental_advices"
          @click="onClick"
        />
        <MainHeaderMenuItemLink
          variant="submenu"
          :text="$t('core.navigation.rental_management')"
          href="https://www.homepilot.fr/"
          target="_blank"
          menu-category1="rent"
          menu-category2="rental_management"
          @click="onClick"
        />
      </div>
    </div>
  </div>
</template>
